import React, { useState } from 'react';
import { Box, TextField, Button, Alert } from '@mui/material';
import instance from '../../utils/axiosConfig';
import { ThemeProvider } from '@mui/material/styles';
import menuTheme from '../../menuTheme';
function CreateAdminForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    isSuperAdmin: false
  });
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await instance.post('/api/admin-management/admins', formData);
      if (response.data.success) {
        setMessage({ type: 'success', text: 'Administrador creado exitosamente' });
        setFormData({ name: '', email: '', password: '', isSuperAdmin: false });
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.error || 'Error al crear administrador' 
      });
    }
  };

  return (
    <ThemeProvider theme={menuTheme}>
    <Box 
      component="form" 
      onSubmit={handleSubmit} 
      sx={{ 
        maxWidth: 400,
        '& .MuiTextField-root': {
          mb: 2
        }
      }}
    >
      {message.text && (
        <Alert 
          severity={message.type} 
          sx={{ 
            mb: 3,
            borderRadius: '6px',
            '& .MuiAlert-message': {
              fontSize: '0.9rem'
            }
          }}
        >
          {message.text}
        </Alert>
      )}

      <TextField
        fullWidth
        variant="outlined"
        label="Nombre"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        required
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
          }
        }}
      />

      <TextField
        fullWidth
        variant="outlined"
        label="Email"
        type="email"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        required
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
          }
        }}
      />

      <TextField
        fullWidth
        variant="outlined"
        label="Contraseña"
        type="password"
        value={formData.password}
        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        required
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
          }
        }}
      />

      <Button 
        type="submit" 
        variant="contained" 
        color="primary"
        fullWidth
        sx={{ 
          mt: 2,
          py: 1.2,
          fontSize: '0.9rem',
          fontWeight: 500,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          }
        }}
      >
        Crear Administrador
      </Button>
    </Box>
    </ThemeProvider>
  );
}

export default CreateAdminForm; 